<div>
  <ng-container *ngIf="!preview; else elseText">
    <mat-form-field class="w-100">
      <input matInput
        [disabled]="preview"
        [value]="getAnswer().answer_text || ''"
        (blur)="handleBlur($event)"
      />
    </mat-form-field>
  </ng-container>

  <ng-template #elseText>
    <p class="raw-text">{{getAnswer().answer_text || ''}}</p>
  </ng-template>

  <!-- Translate section -->
  <ng-container *ngIf="surveyLanguageId!==languageId && getAnswer().answer_text">
    <div class="translate-btn" (click)="translate()">
      <i class="fal fa-language"></i>
      <span>{{'commons.translate' | translate }}</span>
    </div>
  </ng-container>

  <ng-container *ngIf="isTranslatedPressed">
    <ng-container *ngIf="waitTranslate else boxTranslated">
      <mh-spinner-load></mh-spinner-load>
    </ng-container>
  </ng-container>
</div>

<ng-template #boxTranslated>
  <mat-form-field class="w-100 appearance-none tw-mt-2" appearance="outline">
    <textarea matInput
      [disabled]="true"
      [value]="answerTranslated"
    ></textarea>
  </mat-form-field>
</ng-template>
